import React, { useState } from 'react';
import {    
    Routes,
    Route,
    Navigate,    
    HashRouter
  } from "react-router-dom";
import { LoginPage, Settings } from './Pages';
import { EcommerceLandingPage } from './Pages/Ecommerce/EcommerceLanding.page';
import GDPRApprovalRequest from './Pages/Ecommerce/GDPRApprovalRequest';
import GDPRContinueRegister from './Pages/Ecommerce/GDPRContinueRegister';
import { GuardedRoute, Navigation, CRUDRoute, CRUDForm } from './Components';
import CompletedOrderExport from './Pages/Ecommerce/CompletedOrderExport';
import Search  from './Pages/Ecommerce/CustomerModule/Search';
import CustomerDetailsContainer from './Pages/Ecommerce/CustomerModule/CustomerDetailsContainer';
import OrderList from './Pages/Ecommerce/SalesModule/OrderList';
import OrderDetail from './Pages/Ecommerce/SalesModule/OrderDetail';
import AggregateTurnOverExport from './Pages/Ecommerce/AggregateTurnOverExport';
import CompletedOrderOneTimeAndSubscriptionExport from './Pages/Ecommerce/CompletedOrderOneTimeAndSubscriptionExport';

import { isLoggedInCheck, isOnlyEcomCheck } from './Services/Api.service';
import { articlesModel, employeesModel, pagesModel, localCampaignModel, settingsModel } from './Components/model';
import { CRUDRootRoute } from './Components/crud-root-component/CRUDRootRoute';
import { BlockPage } from './Pages/Block/Block.page';
import SubscriptionList from './Pages/Ecommerce/SalesModule/SubscriptionList';
import StoreSettings from './Pages/Ecommerce/StoreSettings';

const BackendApp = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(isLoggedInCheck());
    const [onlyEcom, setonlyEcom] = useState(isOnlyEcomCheck());   
    const [redirectUrl, setredirectUrl] = useState(window.location.href);        

    return (
        <div className="backend__root">
            <Navigation isLoggedIn={isLoggedIn} />

            <div className="backend__body row">
                <div className="columns small-12">                      
                    <Routes>
                        <Route exact path="/" element={isLoggedIn ? <Navigate to={onlyEcom ? '/ecommercelanding' : '/employees'} /> : <LoginPage redirectUrl={redirectUrl}/>}>                            
                        </Route> 
                        <Route path={`/LocalCampaign/edit/:id`} element={<CRUDForm model={localCampaignModel} actionName={`Edit block LocalCampaign`} /> } />                                             
                    </Routes>                         
                    <CRUDRoute auth={isLoggedIn && !onlyEcom} model={articlesModel}></CRUDRoute>
                    <CRUDRoute auth={isLoggedIn && !onlyEcom} model={employeesModel}></CRUDRoute>
                    <CRUDRootRoute auth={isLoggedIn && !onlyEcom} model={pagesModel}></CRUDRootRoute>
                    <GuardedRoute auth={isLoggedIn && !onlyEcom} path="/settings"><Settings /></GuardedRoute>
                    <GuardedRoute auth={isLoggedIn} path="/blocks"><BlockPage /></GuardedRoute>     
                    <GuardedRoute auth={isLoggedIn} path="/ecommercelanding"><EcommerceLandingPage /></GuardedRoute>                                                                                                                   
                    <GuardedRoute auth={isLoggedIn} path="/gdprrequest"><GDPRApprovalRequest /></GuardedRoute>  
                    <GuardedRoute auth={isLoggedIn} path="/gdprcontinue"><GDPRContinueRegister /></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/ordersearch"><CompletedOrderExport FilterCompletedDate={false}/></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/customersearch"><Search /></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/customerdetails"><CustomerDetailsContainer /></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/orderlist"><OrderList /></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/subscriptionlist"><SubscriptionList /></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/orderdetail"><OrderDetail /></GuardedRoute>                    
                    <GuardedRoute auth={isLoggedIn} path="/aggregateturnover"><AggregateTurnOverExport FilterCompletedDate={false}/></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/ordersearchcompleteddate"><CompletedOrderExport FilterCompletedDate={true}/></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/aggregateturnovercompleteddate"><AggregateTurnOverExport FilterCompletedDate={true}/></GuardedRoute> 
                    <GuardedRoute auth={isLoggedIn} path="/storesettings"><StoreSettings /></GuardedRoute>
                    <GuardedRoute auth={isLoggedIn} path="/subscriptionandonetimeexport"><CompletedOrderOneTimeAndSubscriptionExport FilterCompletedDate={false}/></GuardedRoute> 
                </div>
            </div>
        </div>
    )
}

const BackendContainer = () => (
    <HashRouter>
        <BackendApp />
    </HashRouter>
)

export default BackendContainer;